import { TrackedEvents, trackEvent } from 'analytics';
import { logger } from 'monitor';

import { type Bale, isOfflineEvidence, type MaterialEvidence } from '../types';

/**
 * @deprecated
 */
export const trackBaleSopOutcome = (bale: Bale, type: 'frontend' | 'backend' | 'model') => {
  if (bale.analysisStatus && bale.analysisStatus === 'rejected-photo') {
    logger.debug('Tracking SOP failure', bale);
    trackEvent(TrackedEvents.EVIDENCE_UPLOAD_SOP_FAILURE, { reason: bale.photoRejectedReason, type });
    return;
  }

  logger.debug('Tracking SOP success', bale);
  trackEvent(TrackedEvents.EVIDENCE_UPLOAD_SOP_SUCCESS);
};

export const trackEvidenceSopOutcome = (evidence: MaterialEvidence, type: 'frontend' | 'backend' | 'model') => {
  const isOffline = isOfflineEvidence(evidence);
  if (isOffline) {
    return;
  }
  if (evidence.analysisStatus && evidence.analysisStatus === 'rejected-photo') {
    logger.debug('Tracking SOP failure', evidence);
    trackEvent(TrackedEvents.EVIDENCE_UPLOAD_SOP_FAILURE, { reason: evidence.photoRejectedReason, type });
    return;
  }

  logger.debug('Tracking SOP success', evidence);
  trackEvent(TrackedEvents.EVIDENCE_UPLOAD_SOP_SUCCESS);
};
